import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const Admin = ({ setIsAuthenticated }) => {
  const [id, setId] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false); // 비밀번호 보기 상태
  const navigate = useNavigate();

  // 환경변수에서 아이디와 비밀번호 가져오기
  const adminId = process.env.REACT_APP_ADMIN_ID;
  const adminPassword = process.env.REACT_APP_ADMIN_PASSWORD;

  const handleLogin = () => {
    console.log(adminId, adminPassword);
    // 입력값과 환경변수 비교
    if (id === adminId && password === adminPassword) {
      setIsAuthenticated(true); // 인증 상태 업데이트
      navigate("/notice"); // New.js로 이동
    } else {
      alert("아이디 또는 비밀번호가 잘못되었습니다.");
    }
  };

  return (
    <div className="admin">
      <div className="admin_box">
        <h4>관리자 모드</h4>
        <input
          type="text"
          placeholder="아이디"
          value={id}
          onChange={(e) => setId(e.target.value)}
        />
        <br />
        <input
          type={showPassword ? "text" : "password"} // 비밀번호 보기 상태에 따라 type 변경
          placeholder="비밀번호"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <label>
          <input
            type="checkbox"
            checked={showPassword}
            onChange={(e) => setShowPassword(e.target.checked)} // 체크박스 상태 업데이트
          />
          비밀번호 보기
        </label>
        <br />
        <button onClick={handleLogin}>로그인</button>
      </div>
    </div>
  );
};

export default Admin;